// extracted by mini-css-extract-plugin
module.exports = {"radio":"YCTkcg9 _2wW_gNj","terms":"_3FP4a1h","terms_block":"_2d4agdy"};